import { getAppFeatures } from '@utils/getAppFeatures'
import { useEffect } from 'react'

export const useAppFavicon = (): void => {
  const features = getAppFeatures()

  useEffect(() => {
    if (!features?.resources?.favicon) return
    // Create a new link element
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = features?.resources?.favicon

    // Remove any existing favicon elements
    const existingFavicons = document.querySelectorAll('link[rel="icon"]')
    existingFavicons.forEach((favicon) =>
      favicon.parentNode.removeChild(favicon),
    )

    // Append the new favicon to the head
    document.head.appendChild(link)

    // Cleanup function to remove the favicon when the component unmounts
    return () => {
      if (link.parentNode) {
        link.parentNode.removeChild(link)
      }
    }
  }, [features?.resources?.favicon])
}
